<template>
  <div>
    <el-dialog 
      title="Formulário NFe"
      center 
      width="640"
      :visible.sync="dialog"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <div class="row">
           <div class="col-md-6">
            <div class="form-group is-required">
              <label for="nfeChave">Chave da NFe:</label>
              <input type="text" class="form-control" id="nfeChave" v-model="form.nfeChave" required>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="nfeNumero">Número da NFe:</label>
              <input type="text" class="form-control" id="nfeNumero" v-model="form.nfeNumero" required>
            </div>
          </div>          
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="nfeSerie">Série da NFe:</label>
              <input type="text" class="form-control" id="nfeSerie" v-model="form.nfeSerie" required>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="nfeData">Data da NFe:</label>
              <input type="date" class="form-control" id="nfeData" v-model="form.nfeData" required>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="nfeValTotal">Valor Total:</label>
              <input type="number" class="form-control" id="nfeValTotal" v-model="form.nfeValTotal">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="nfeValProd">Valor do Produto:</label>
              <input type="number" class="form-control" id="nfeValProd" v-model="form.nfeValProd">
            </div>
          </div>
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div div class="bottom clearfix">
              <el-button type="success" title="Anexa dados da NFe" @click="submitForm()" class="mx-auto d-block">Anexa dados da NFe</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PrePostNfe",
  props: ["dialog"],
  data() {
    return {
      form: {
        nfeNumero: '',
        nfeSerie: '',
        nfeData: '',
        nfeValTotal: null,
        nfeValProd: null,
        nfeChave: ''
      }
    };
  },
  methods: {
    submitForm() {
      console.log('Formulário submetido:', this.form);
      // this.resetForm();
    
    },
    resetForm() {
      this.form = {
        nfeNumero: '',
        nfeSerie: '',
        nfeData: '',
        nfeValTotal: null,
        nfeValProd: null,
        nfeChave: ''
      };
    }
  }
};
</script>
